export function gasCalculator(rides: number, price: number) {
    return rides * price;
}
